import type { CSSProperties } from 'react'
import type { LucideIcon } from 'lucide-react'
import { CORAL, INK, MARIGOLD, NIGHT } from '../tokens'

type BadgeTone = 'marigold' | 'coral' | 'night'

interface IconBadgeProps {
  icon: LucideIcon
  tone?: BadgeTone
  /** Slight rotation gives the sticker feel from the mockup; set 0 to keep it square. */
  rotate?: number
  size?: number
  style?: CSSProperties
}

const fills: Record<BadgeTone, { bg: string; fg: string }> = {
  marigold: { bg: MARIGOLD, fg: INK },
  coral: { bg: CORAL, fg: '#fff' },
  night: { bg: NIGHT, fg: '#fff' },
}

/**
 * The rounded, slightly-rotated sticker icon tile from Direction F -- flat
 * fills only, never a gradient. Replaces the rainbow of unrelated
 * stock-Tailwind icon colors the audit found (rewise-ui Dashboard.tsx,
 * super-admin's tile rows).
 */
export function IconBadge({ icon: Icon, tone = 'coral', rotate = 0, size = 44, style }: IconBadgeProps) {
  const { bg, fg } = fills[tone]
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.32,
        background: bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: rotate ? `rotate(${rotate}deg)` : undefined,
        flexShrink: 0,
        ...style,
      }}
    >
      <Icon size={size * 0.5} color={fg} strokeWidth={2.2} />
    </div>
  )
}
